export type Variant = 'stroke' | 'solid' | 'membership';

export function getBannerStyles(variant: Variant) {
  switch (variant) {
    case 'stroke':
      return {
        title: 'text-paragraph',
        banner: 'bg-primary-air border border-blue-600',
        button: 'bg-primary-regular text-inverse',
      };
    case 'solid':
      return {
        title: 'text-inverse',
        banner: 'bg-blue-1100',
        button: 'bg-secondary-air text-normal',
      };
    case 'membership':
      return {
        title: 'text-bonuspackGreen-text',
        banner: 'bg-[#F0FFF9] border border-[#21AB73]',
        button: 'bg-primary-regular text-inverse',
      };
    default:
      return {
        title: 'text-paragraph',
        banner: 'bg-primary-air border border-blue-600',
        button: 'bg-primary-regular text-inverse',
      };
  }
}

export function getFloatingStyles(variant: Variant) {
  switch (variant) {
    case 'stroke':
      return {
        title: 'text-paragraph',
        banner: 'border border-blue-600 bg-[rgba(243,250,255,0.95)]',
        close: '',
      };
    case 'solid':
      return {
        title: 'text-inverse',
        banner: 'bg-[rgba(20,60,151,0.95)]',
        close: 'text-gray-000',
      };
    case 'membership':
      return {
        title: 'text-[#008745]',
        banner: 'border border-[#21AB73] bg-[rgba(240,255,249,0.95)]',
        close: '',
      };
    default:
      return {
        title: 'text-paragraph',
        banner: 'border border-blue-600 bg-[rgba(243,250,255,0.95)]',
        close: '',
      };
  }
}
